// AdminEmployees.jsx
import React, { useState } from 'react';
import { Users, UserPlus } from 'lucide-react';
import TabPageLayout from 'modules/swiftboard/components/TabPageLayout';
import OnlineUsers from './online-users/OnlineUsers';
import LoginHistory from './login-history/LoginHistory';
import LoginAttempt from './login-attempt/LoginAttempt';
import useUrlTab from "modules/swiftboard/components/useUrlTab";
 
const UserActivity = () => {
 
  const [activeTab, setActiveTab] = useUrlTab(["online-users", "login-history", "login-attempts"]);
  const [tabCounts, setTabCounts] = useState({});

  const setTabCount = (tabId) => (count) =>
    setTabCounts((prev) => (prev[tabId] === count ? prev : { ...prev, [tabId]: count }));
 
  const centralDirectoryTabs = [
    {
      id: 1,
      label: 'Online Users',
      icon: <Users size={18} />,
    },
    {
      id: 2,
      label: 'Login History',
      icon: <UserPlus size={18} />,
    },
    {
      id: 3,
      label: 'Login Attempts',
      icon: <UserPlus size={18} />,
    },
  ].map((tab, index) => ({
    ...tab,
    badge:
      index === activeTab && tabCounts[tab.id] !== undefined
        ? { count: tabCounts[tab.id], compact: true }
        : undefined,
  }));

  const handleTabChange = (index, tab) => {
    setActiveTab(index);
  }; 
  return (
    <TabPageLayout
      tabs={centralDirectoryTabs}
      activeTab={activeTab}
      onTabChange={handleTabChange}
    >
      {activeTab === 0 && <OnlineUsers onTotalCountChange={setTabCount(1)} />}
      {activeTab === 1 && <LoginHistory onTotalCountChange={setTabCount(2)} />}
      {activeTab === 2 && <LoginAttempt onTotalCountChange={setTabCount(3)} />}
    </TabPageLayout>
  );
};

export default UserActivity;